import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import SmsOptIn from './pages/SmsOptIn';
import Sitemap from './pages/Sitemap';
import CookieNotice from './components/CookieNotice';

// Routes only — no router. App.jsx wraps this in a BrowserRouter for the
// browser; the prerender entry wraps it in a StaticRouter to emit static HTML.
const AppShell = () => (
  <div className="min-h-screen flex flex-col">
    <Header />
    <div className="flex-grow">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/sms-optin" element={<SmsOptIn />} />
        <Route path="/sitemap" element={<Sitemap />} />
        {/* Anything unrecognized goes home rather than rendering a blank page. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
    <Footer />
    <CookieNotice />
  </div>
);

export default AppShell;
